
import { ReactComponent as FiltersIcon } from "../../../assets/icons/regular/bars_filters.svg";
import { Filters } from "../dialogs/Filters";
import { Search } from "../Search"
import { Badge } from "../Search/Search.styles";
import { useSearchSection } from "./SearchSection.hooks";
import { ButtonsContainer, ClearFiltersButton, Container, FiltersButton } from "./SearchSection.styles"

export const SearchSection = () => {
  const { 
    filtersExists,
    openFiltersModal,
    setOpenFiltersModal,
    clearSearchParams
} = useSearchSection();
  return (
    <Container>
      <Search />
      <ButtonsContainer>
        <FiltersButton onClick={() => setOpenFiltersModal(true)}>
          <FiltersIcon />
          {filtersExists
            ?
              <>
                <Badge />
                Applied filters
              </>
            : "Apply filters"
          }
        </FiltersButton>
        <ClearFiltersButton onClick={clearSearchParams}>
          Clear filters
        </ClearFiltersButton>
      </ButtonsContainer>
      {openFiltersModal &&
        <Filters 
          open={openFiltersModal}
          setOpen={setOpenFiltersModal}
        />
      }
    </Container>
  )
}